module.exports = __webpack_public_path__ + "static/media/CardComp.a148ee28.png";